/*
  Produktbilder scrollbar – Hanf & Natur (30.10.2026), Gestaltung in assets/hn-design.css
  - Trackpad: waagerecht über das Hauptbild wischen blättert zum nächsten bzw. vorigen Bild
    (ein Wisch = ein Bild, der Nachlauf des Trackpads wird abgewartet). Umschalt + Mausrad ebenso.
    Senkrechtes Scrollen über dem Bild scrollt weiter die Seite.
  - Pfeile am Hauptbild (snippets/product-images.liquid, data-hn-galerie) blättern ebenfalls.
  Der Slider selbst bleibt Flickity aus theme.js (Ziehen, Wischen am Handy, Vorschaubilder, Varianten).
*/
(function () {
  function slider(el) {
    var fotos = el.closest('.product__main-photos');
    var s = fotos && fotos.querySelector('[data-product-photos]');
    return s && window.Flickity ? window.Flickity.data(s) : null;
  }

  function verbinden(root) {
    root.querySelectorAll('.product__main-photos').forEach(function (fotos) {
      if (fotos.hasAttribute('data-hn-wisch')) return;
      fotos.setAttribute('data-hn-wisch', '');

      var summe = 0;
      var gesperrt = false;
      var ruhe;

      fotos.addEventListener('wheel', function (e) {
        var x = e.deltaX;
        if (!x && e.shiftKey) x = e.deltaY;
        if (!e.shiftKey && Math.abs(x) <= Math.abs(e.deltaY)) return;

        var flkty = slider(fotos);
        if (!flkty || flkty.cells.length < 2) return;

        e.preventDefault();
        clearTimeout(ruhe);
        ruhe = setTimeout(function () {
          gesperrt = false;
          summe = 0;
        }, 160);
        if (gesperrt) return;

        summe += x;
        if (Math.abs(summe) > 30) {
          if (summe > 0) {
            flkty.next();
          } else {
            flkty.previous();
          }
          gesperrt = true;
          summe = 0;
        }
      }, { passive: false });
    });
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-hn-galerie]');
    if (!knopf) return;
    var flkty = slider(knopf);
    if (!flkty) return;
    if (knopf.getAttribute('data-hn-galerie') === 'zurueck') {
      flkty.previous();
    } else {
      flkty.next();
    }
  });

  verbinden(document);
  document.addEventListener('shopify:section:load', function (e) {
    verbinden(e.target);
  });
})();
